import GiftCardsPreviewList from './GiftCardsPreviewList';

export default GiftCardsPreviewList;
